import { render, staticRenderFns } from "./RolePermissionEditor.vue?vue&type=template&id=64ece31d"
import script from "./RolePermissionEditor.vue?vue&type=script&lang=js"
export * from "./RolePermissionEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports